document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.toggle-password');
  if (!toggles.length) return;

  function togglePassword(toggle) {
    const wrapper = toggle.closest('.password-wrapper');
    if (!wrapper) return;

    const input = wrapper.querySelector('input');
    if (!input) return;

    const isHidden = input.type === 'password';
    input.type = isHidden ? 'text' : 'password';

    toggle.classList.toggle('is-visible', isHidden);
    toggle.setAttribute('aria-pressed', String(isHidden));
    toggle.setAttribute(
      'aria-label',
      isHidden ? 'Masquer le mot de passe' : 'Afficher le mot de passe'
    );
  }

  toggles.forEach((toggle) => {
    // pour le clavier (span non focusable par défaut)
    if (!toggle.hasAttribute('tabindex')) toggle.setAttribute('tabindex', '0');
    if (!toggle.hasAttribute('role')) toggle.setAttribute('role', 'button');

    toggle.addEventListener('click', function () {
      togglePassword(toggle);
    });

    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        togglePassword(toggle);
      }
    });
  });
});
